import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsProviderService {

  baseApiUrl = '';
  baseUrl = `${window.location.origin}/`;
  appVersion = 'v2.0.0';

  constructor(baseApiUrl: string) {
    this.baseApiUrl = this.baseUrl + baseApiUrl;
  }
}
